import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=6ac9f596&lang=pug"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports